"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearErrors = exports.setRequestStatus = exports.RequestStatusSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    loading: false,
    requests: {},
    errors: [],
};
exports.RequestStatusSlice = (0, toolkit_1.createSlice)({
    name: 'RequestStatusSlice',
    initialState: initialState,
    reducers: {
        setRequestStatus: function (state, action) {
            state.requests[action.payload.requestId] = __assign({}, action.payload);
            var errors = Object.values(state.requests).reduce(function (prev, curr) {
                var _a, _b;
                if (curr.error && !curr.background) {
                    return __spreadArray(__spreadArray([], prev, true), [((_b = (_a = curr.error.errorCode) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : curr.error.message)], false);
                }
                return prev;
            }, []);
            state.errors = errors;
            state.loading = Object.values(state.requests).reduce(function (prev, curr) { return prev || (curr.loading && !curr.background); }, false);
        },
        clearErrors: function (state) {
            state.errors = [];
            state.requests = state.requests ? Object.keys(state.requests).reduce(function (prev, curr) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[curr] = __assign(__assign({}, state.requests[curr]), { error: null }), _a)));
            }, {}) : {};
        },
    },
});
exports.setRequestStatus = (_a = exports.RequestStatusSlice.actions, _a.setRequestStatus), exports.clearErrors = _a.clearErrors;
exports.default = exports.RequestStatusSlice.reducer;
